<template>
  <div class="productsbox">
    <section id="banner">
          <div
            class="wrapper"
            :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"
          ></div>
        </section>
        <section id="breadcrumb" style="position: static; top: 0px;">
          <div class="wrapper">
            <img src="../assets/breadcrumb.png" />
            <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;{{categoryInfo.name}}&nbsp;&gt;&nbsp;
            <router-link
              :to="{path: '/products', query: {typeId: productInfo.productType, categoryId: categoryId}}"
            >{{productInfo.typeName}}</router-link>
            &nbsp;&gt;&nbsp;{{productInfo.name}}
          </div>
        </section>
    <div class="box">
      <div class="newsbodyr" style>


        <div class="prdo">
          <div class="prdo2 clearfix" style>
            <div class="prdo3" style>
              <a id="bigpic">
                <img :src="productBanner" id="middlepic" />
              </a>
            </div>

            <div class="prdo4">
              <div
                class="prdo5"
                style="padding-bottom: 0; line-height: 28px; font-size: 18px;"
              >{{productInfo.name}}</div>
              <div class="prdo6">产品系列：{{productInfo.lineName}}</div>
              <div class="prdo66" v-html="productInfo.description"></div>
              <div class="prdo7 clearfix">
                <ul>
                  <li
                    @click="showImg(item)"
                    v-for="(item, index) in productInfo.thumbs"
                    :key="index"
                  >
                    <a>
                      <img :src="item" alt />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="xgdg10" style>
          <div class="xgdg11 clearfix">
            <a :class="show? 'xgdg11oa' : ''" @click="showlink2(1)" style id="glxx1">产品概述</a>
            <a :class="show? '' : 'xgdg11oa'" @click="showlink2(2)" style id="glxx2">资料下载</a>
          </div>
        </div>

        <div id="message">
          <div v-show="show" class="prgs" style="color: #333;  overflow: hidden; ">
            <div v-html="productInfo.productDetail"></div>
          </div>
          <div v-show="!show" class="prcs" id="content" style="padding: 20px 0 40px 36px;">
            可以发送邮件到support@adritas.com获取资料
          </div>
        </div>
        <!-- <div v-show="show" style="padding: 0 36px 20px 36px;border-top: none;">产品更新时间：2017-08-03</div> -->
        <!-- <div v-show="show" 
          style="padding: 0 68px 50px 36px;border-top: none;"
        >同一型号产品可能有多个版本，不同版本的产品会存在差异（包括功能参数、LOGO设计、外观细节、产品资料等），请以实物为准。</div> -->
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo } from '@/api/content'
import { getProductInfo } from "@/api/product";
export default {
  name: "",
  data() {
    return {
      show: true,
      show2: 1,
      id: this.$route.query.id,
      categoryId: this.$route.query.categoryId,
      productInfo: {
        thumbs: [],
      },
      productBanner: "",
      categoryInfo: {}
    };
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then(res => {
        if (res.code !== 200) return
        this.categoryInfo = res.data
        this.categoryInfo.categoryPic = process.env.BASE_API + '/web' + this.categoryInfo.categoryPic
      })
    },
    showlink2(e) {
      console.log(e);
      if (e == 1) {
        this.show = true;
      } else if (e == 2) {
        this.show = false;
      }
    },
    showlink4(e) {
      this.show2 = e;
    },
    getProductInfo() {
      getProductInfo(this.id).then((res) => {
        if (res.code !== 200) return;
        this.productInfo = res.data;
        this.productBanner =
          process.env.BASE_API + "/web" + this.productInfo.productPic;
        let pics = this.productInfo.pics;
        let arr = pics.split(",");
        this.productInfo.thumbs = [];
        arr.forEach((item) => {
          item = process.env.BASE_API + "/web" + item;
          this.productInfo.thumbs.push(item);
        });
        this.productInfo.description = this.productInfo.description.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ').replace(' ', '&nbsp;');
      });
    },
    showImg(item) {
      this.productBanner = item;
    },
  },
  mounted() {
    this.getProductInfo();
    this.getBanner()
  }
};
</script>

<style scoped >
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
.box {
  width: 100%;
}
.newsbodyr {
  width: 1280px;
  margin: 0 auto;

}
@media screen and (max-width: 1300px) {
  .box .newsbodyr {
    width: 90%;
    margin: 0 auto;
  }
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
#breadcrumb .wrapper a {
  color: #333;
}

@media screen and (max-width: 760px) {
  .box .productsbox .box .newsbodyr {
    width: 100%;
    margin: 0 auto;
  }
  .productsbox section#banner .wrapper {
    height: 160px;
  }
}
@media screen and (max-width: 1000px) {
  section#banner .wrapper {
    background-size: auto 100%;
  }
}
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  /* background: ; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
@media screen and (max-width: 1300px) {
  .newsbodyr .prdo2 {
    padding-top: 35px;
    padding-left: 30px;
  }
}

@media screen and (max-width: 760px) {
  .productsbox .box .newsbodyr .prdo2 {
    padding-top: 20px;
    padding-left: 20px;
  }
}

.prdo2 {
  padding-top: 57px;
  padding-left: 66px;
}
.clearfix {
  zoom: 1;
}
@media screen and (max-width: 1300px) {
  .box .newsbodyr .nbrtop {
    width: 100%;
  }
}

.nbrtop {
  width: 912px;
  padding-bottom: 10px;
  z-index: 2;
}
.nbrtopl {
  float: left;
  padding-left: 2px;
  height: 30px;
  overflow: hidden;
  line-height: 38px;
}
.nbrtopl a {
  color: #3b3b3b;
  font-size: 18px;
  line-height: 38px;
  background: url(../assets/xgpic7.jpg) no-repeat left;
  padding-left: 24px;
}
.nbrtopl span {
  padding-left: 2px;
  padding-right: 2px;
  font-size: 16px;
}
.nbrtopl a.nbrtopla {
  font-size: 16px;
  color: #c0130a;
}
.nbrtopl a {
  color: #3b3b3b;
  font-size: 18px;
  line-height: 38px;
  background: url(../assets/xgpic7.jpg) no-repeat left;
  padding-left: 24px;
}
.prdo {
  border: 1px solid #e1e1e1;
  border-bottom: 5px solid #e1e1e1;
  background: #fff;
  width: 100%;
  position: relative;
  padding-bottom: 38px;
}
@media screen and (max-width: 760px) {
  .box .newsbodyr .prdo3 {
    width: 90%;
    padding: 10px 5%;
  }
}
@media screen and (max-width: 1200px) {
  .box .newsbodyr .prdo3 {
    width: 35%;
    padding-right: 20px;
  }
}
.prdo3 {
  width: 253px;
  height: 184px;
  overflow: hidden;
  padding-right: 50px;
  float: left;
}
.prdo3 a {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
}
.prdo3 a img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 760px) {
  .box .newsbodyr .prdo4 {
    width: 90%;
    padding: 10px 5%;
  }
}
#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
  /* border: 1px solid #c8c9cb; */
}
@media screen and (max-width: 1300px) {
  .productsbox #breadcrumb .wrapper {
    width: 100%;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
@media screen and (max-width: 1200px) {
  .box .newsbodyr .prdo4 {
    width: 55%;
  }
}
.prdo4 {
  float: left;
  width: 510px;
}

.prdo5 {
  font-family: "微软雅黑";
  color: #cd261d;
  padding-bottom: 12px;
  line-height: 28px;
  font-size: 18px;
}
.prdo6 {
  color: #4c4d4f;
  font-size: 14px;
  line-height: 22px;
  font-size: 14px;
  font-family: "微软雅黑", arial;
}
.prdo7 {
  padding-top: 20px;
}
.prdo7 ul {
  width: 100%;
}
.prdo7 ul li {
  display: inline-block;
  width: 89px;
  height: 65px;
  margin-right: 10px;
}
.prdo7 a img {
  display: block;
  width: 89px;
  height: 65px;
}
.xgdg10 {
  width: 100%;
  border: 1px solid #dbdbd0;
  border-top: none;
  width: 100%;
  background: #eeeee4;
  height: 44px;
  position: relative;
}
.xgdg11 {
  height: 44px;
  position: absolute;
  left: 0;
  top: 0;
}
.xgdg11 a.xgdg11oa {
  border-bottom: 4px solid #464639;
  padding-bottom: 0;
  background: #d7d7c9;
}
.xgdg11 a {
  display: block;
  float: left;
  font-size: 14px;
  color: #182941;
  height: 40px;
  line-height: 40px;
  padding-left: 32px;
  padding-right: 34px;
  padding-bottom: 4px;
}
#message {
  width: 96%;
}

.prgs {
  padding-left: 36px;
  padding-bottom: 30px;
  line-height: 24px;
  font-size: 12px;
  padding-top: 8px;
  height: auto !important;
  min-height: 92px;
  height: 92px;
  color: #333333;
}
.prcs1 {
  margin: 0 auto;
  padding-top: 16px;
  border-bottom: 1px solid #e3e3e3;
  width: 100%;
}
.prcs1 a.prcs1oa {
  background: none;
  color: #c4261d;
}
.prcs1 a {
  display: block;
  border: 1px solid #e3e3e3;
  border-bottom: none;
  background: #eee;
  height: 28px;
  line-height: 28px;
  color: #444;
  float: left;
  padding-left: 16px;
  padding-right: 16px;
  margin-right: 6px;
  font-size: 14px;
  white-space: nowrap;
}

table {
  width: 100%;
}

.prcs2 td {
  background: #fff;
  color: #333;
  line-height: 22px;
  padding-left: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  word-break: break-all;
  padding-left: 5px;
  border-right: 1px solid #dedede;
  border-top: 1px solid #dedede;
  padding-top: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/pro_detail.vue